
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streamers/collections",
      function () {
        return require("private-next-pages/streamers/collections/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streamers/collections"])
      });
    }
  